import React, { createContext, memo, useEffect, useRef, useState } from "react";

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Slide,
  Typography,
} from "@material-ui/core";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import useCallFeature from "hooks/context-hooks/useCallFeature";
import useUpsertAppointment from "hooks/useUpsertAppointment";
import useUpsertContact from "hooks/useUpsertContact";
import { patientStatus } from "utils/ArrayUtils";
import AllConvoNew from "./AllConvoNew";
import DFIconButton from "./DFCustoms/DFIconButton";
import { DFOutgoingCall } from "./DFIcons";
import PatientStatusIcons from "./DFIcons/PatientStatusIcons";
import SendMessageBox from "./SendMessageBox";
import Notes from "./Notes/Notes";
import NoteItem from "./Notes/NoteItem";
import NoteIcon from "@material-ui/icons/Note";
import { useFetchPinnedLogs } from "utils/hooks/apiHooks/notes-feature/useFetchPinnedLogs";
import useMediaQuery from "hooks/useMediaQuery";
import { useDivHeight } from "hooks/useDivHeight";
import PinnedItem from "./Notes/PinnedItem";
import { useFetchPatientNotes } from "utils/hooks/apiHooks/notes-feature/useFetchPatientNotes";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});
export const PinnedLogsContext = createContext();

const AllLogHistoryNew = ({
  isOpen,
  logHistoryProps,
  close,
  updatepatient,
  patient,
  user,
  isResponsive = false,
}) => {
  const isDialogMode = useMediaQuery("(max-width: 1200px)");

  return (
    <div className="log-history">
      {(isDialogMode || !isResponsive) && (
        <Dialog
          fullScreen
          TransitionComponent={Transition}
          scroll="paper"
          open={isOpen}
          onClose={close}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <Content
            patient={patient}
            close={close}
            user={user}
            patientStatus={patientStatus}
            updatepatient={updatepatient}
            logHistoryProps={logHistoryProps}
          />
        </Dialog>
      )}

      {!isDialogMode && isResponsive && (
        <div style={{ overflow: "scroll", height: "90vh" }}>
          <Content
            patient={patient}
            close={close}
            user={user}
            patientStatus={patientStatus}
            updatepatient={updatepatient}
            logHistoryProps={logHistoryProps}
          />
        </div>
      )}
    </div>
  );
};
export default memo(AllLogHistoryNew);

const Content = ({
  patient,
  close,
  logHistoryProps,
  user,
  patientStatus,
  updatepatient,
}) => {
  const [renderContactForm, { upsertContact }] = useUpsertContact(
    user,
    updatepatient
  );
  const [notes, loadingNotes, refetchNotes] = useFetchPatientNotes(
    patient?.patientID
  );
  const [pinnedLogs, loadingPinnedLogs, refetchPinnedLogs] = useFetchPinnedLogs(
    patient.patientID
  );
  const [renderAppointmentForm, { openAppointmentForm }] =
    useUpsertAppointment(user);

  const { makeACall } = useCallFeature();

  const handleOpenDetails = () => {
    upsertContact({
      ...patient,
      id: patient.patientID,
    });
  };

  const handleOpenAppointment = () => {
    openAppointmentForm({
      ...patient,
      id: patient.patientID,
    });
  };

  const handleCall = (event) => {
    makeACall(patient);
    event.stopPropagation();
  };

  const { ref, height } = useDivHeight();
  const [openNotes, setOpenNotes] = useState(false);
  return (
    <>
      <DialogTitle
        disableTypography
        style={{
          textTransform: "capitalize",
          padding: "8px 0",
          backgroundColor: patientStatus(
            patient.patientStatus,
            "value",
            "main_color"
          ),
          color: "white",
          display: "flex",
          gap: 8,
          alignItems: "center",
        }}
      >
        <DFIconButton
          onClick={close}
          color="inherit"
          icon={<ArrowBackIosIcon />}
        />

        <PatientStatusIcons
          status={patientStatus(patient.patientStatus, "value", "name")}
        />

        <Typography
          noWrap
          variant="h6"
          onClick={handleOpenDetails}
          style={{ cursor: "pointer" }}
        >
          {patient.patientName}
        </Typography>

        <div
          style={{
            display: "flex",
            color: "white",
            marginLeft: "auto",
            marginRight: "5px",
          }}
        >
          <DFIconButton
            onClick={() => {
              setOpenNotes(true);
            }}
            color="inherit"
            icon={<NoteIcon />}
          />
          <DFIconButton
            onClick={handleOpenDetails}
            color="inherit"
            icon={<InfoOutlinedIcon />}
          />
          <DFIconButton
            onClick={handleCall}
            color="inherit"
            icon={<DFOutgoingCall />}
          />
          <DFIconButton
            onClick={handleOpenAppointment}
            color="inherit"
            icon={<CalendarTodayIcon />}
          />
        </div>
      </DialogTitle>

      <PinnedLogsContext.Provider
        value={{
          refetchPinnedLogs,
          pinnedLogs,
          refetchLogHistory: logHistoryProps?.refetch,
          refetchNotes,
        }}
      >
        <div
          style={{
            position: "sticky",

            backgroundColor: `${patientStatus(
              patient.patientStatus,
              "value",
              "light_color"
            )}`,
            padding: 5,
          }}
          ref={ref}
        >
          {pinnedLogs?.map((item) => {
            return (
              <PinnedItem
                {...(item.log_type !== "Note"
                  ? { backgroundColor: "white" }
                  : {})}
                key={item.id}
                content={item?.body}
                foldColor={`${patientStatus(
                  patient.patientStatus,
                  "value",
                  "light_color"
                )}`}
                isPinned={true}
                fullWidth
                type={item.log_type}
                logId={item.log_type_id}
                username={item?.user_name}
                date={item?.pinned_at}
              />
            );
          })}
        </div>

        <DialogContent
          style={{
            backgroundColor: patientStatus(
              patient.patientStatus,
              "value",
              "light_color"
            ),
            height: `calc(100% - ${height + 130}px)`,
            scroll: "auto",
          }}
          dividers={true}
        >
          <AllConvoNew
            logHistoryProps={logHistoryProps}
            patient={patient}
            updatepatient={updatepatient}
            user={user}
            refetchPinnedLogs={refetchPinnedLogs}
          />
        </DialogContent>
        <Notes
          open={openNotes}
          setOpenNotes={setOpenNotes}
          patientId={patient.patientID}
          data={notes}
          refetch={refetchNotes}
        />
      </PinnedLogsContext.Provider>

      {!!patient.patientID && (
        <DialogActions>
          <SendMessageBox logHistoryProps={logHistoryProps} patient={patient} />
        </DialogActions>
      )}

      {renderContactForm()}
      {renderAppointmentForm()}
    </>
  );
};
